export const loadState = () => {
    try {
        const serializedState = localStorage.getItem("state");
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        console.log("Error on loading state from local storage");
        return undefined;
    }
};

export const saveState = state => {
    try {
        const stateToSave = {
            context: state.context,
            auth: state.auth,
        };
        const serializedState = JSON.stringify(stateToSave);
        localStorage.setItem("state", serializedState);
    } catch (err) {
        console.log("Error on saving state to local storage");
    }
};